/**
 * Popup Delay & Exit Intent Handler
 * Delays mystery gift and other popups by 5-10 seconds or shows on exit intent
 */
(function() {
    'use strict';

    let popupShown = false;
    let exitIntentTriggered = false;
    let pageLoadTime = Date.now();
    const DELAY_MIN = 5000; // 5 seconds
    const DELAY_MAX = 10000; // 10 seconds
    const DELAY_TIME = DELAY_MIN + Math.random() * (DELAY_MAX - DELAY_MIN);

    // Check if popup was already shown (localStorage)
    const popupShownKey = 'mystery_gift_popup_shown';
    const popupShownDate = localStorage.getItem(popupShownKey);
    const oneDayAgo = Date.now() - (24 * 60 * 60 * 1000);

    // Don't show if shown in last 24 hours
    if (popupShownDate && parseInt(popupShownDate) > oneDayAgo) {
        return;
    }

    /**
     * Override ModalDialog show method to intercept all popup shows
     */
    function overrideModalDialog() {
        // Wait for ModalDialog to be defined
        const checkInterval = setInterval(function() {
            if (window.customElements && customElements.get('modal-dialog')) {
                clearInterval(checkInterval);

                const ModalDialogClass = customElements.get('modal-dialog');
                const originalShow = ModalDialogClass.prototype.show;

                ModalDialogClass.prototype.show = function(opener) {
                    // Check if this is a gift/promo popup
                    const modalContent = this.textContent || '';
                    const isGiftPopup = /mystery|gift|free|promo|discount|offer|special/i.test(modalContent) ||
                        this.classList.contains('gift-popup') ||
                        this.id && /gift|mystery|promo/i.test(this.id);

                    // Skip product/cart modals
                    const isProductModal = this.classList.contains('product-media-modal') ||
                        this.classList.contains('cart-drawer') ||
                        this.classList.contains('quick-add-modal') ||
                        this.id && (this.id.includes('ProductModal') || this.id.includes('Cart'));

                    if (isGiftPopup && !isProductModal && !popupShown) {
                        // Schedule delayed popup instead of showing immediately
                        schedulePopup(this, originalShow, opener);
                        return;
                    }

                    // For other modals, show normally
                    return originalShow.call(this, opener);
                };
            }
        }, 50);

        // Stop checking after 5 seconds
        setTimeout(function() {
            clearInterval(checkInterval);
        }, 5000);
    }

    /**
     * Find and intercept popups
     */
    function findAndInterceptPopups() {
        // Override ModalDialog class
        overrideModalDialog();

        // Find all modal-dialog elements
        const modals = document.querySelectorAll('modal-dialog, [class*="popup"], [class*="modal"], [id*="popup"], [id*="modal"]');

        modals.forEach(function(modal) {
            // Skip product modals and cart modals
            if (modal.classList.contains('product-media-modal') ||
                modal.classList.contains('cart-drawer') ||
                modal.classList.contains('quick-add-modal') ||
                modal.id && (modal.id.includes('ProductModal') || modal.id.includes('Cart'))) {
                return;
            }

            // Check if it's a mystery gift or promotional popup
            const modalContent = modal.textContent || '';
            const isGiftPopup = /mystery|gift|free|promo|discount|offer|special/i.test(modalContent) ||
                modal.classList.contains('gift-popup') ||
                modal.id && /gift|mystery|promo/i.test(modal.id);

            if (isGiftPopup || modal.hasAttribute('open') || modal.style.display === 'block') {
                // Hide immediately if showing
                modal.removeAttribute('open');
                modal.style.display = 'none';
                modal.style.visibility = 'hidden';
                modal.style.opacity = '0';

                // Override show method if it exists
                if (typeof modal.show === 'function') {
                    const originalShow = modal.show.bind(modal);
                    modal.show = function(opener) {
                        if (!popupShown) {
                            schedulePopup(modal, originalShow, opener);
                        }
                    };
                }

                // Monitor for auto-show attempts
                const observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                            if (modal.hasAttribute('open') && !popupShown) {
                                modal.removeAttribute('open');
                                schedulePopup(modal);
                            }
                        }
                        if (mutation.type === 'attributes' &&
                            (mutation.attributeName === 'style' || mutation.attributeName === 'class')) {
                            const display = window.getComputedStyle(modal).display;
                            const visibility = window.getComputedStyle(modal).visibility;
                            if ((display === 'block' || visibility === 'visible') && !popupShown) {
                                modal.style.display = 'none';
                                modal.style.visibility = 'hidden';
                                schedulePopup(modal);
                            }
                        }
                    });
                });

                observer.observe(modal, {
                    attributes: true,
                    attributeFilter: ['open', 'style', 'class'],
                    childList: false,
                    subtree: false
                });

                // Schedule delayed popup
                schedulePopup(modal);
            }
        });
    }

    /**
     * Schedule popup to show after delay or on exit intent
     */
    function schedulePopup(modal, showMethod, opener) {
        if (popupShown) return;

        let timeoutId = null;
        let exitIntentHandler = null;

        // Function to show popup
        function showPopup() {
            if (popupShown) return;
            popupShown = true;

            if (timeoutId) clearTimeout(timeoutId);
            if (exitIntentHandler) {
                document.removeEventListener('mouseleave', exitIntentHandler);
            }

            // Mark as shown in localStorage
            localStorage.setItem(popupShownKey, Date.now().toString());

            // Show the popup
            if (showMethod) {
                if (opener) {
                    showMethod.call(modal, opener);
                } else {
                    showMethod.call(modal);
                }
            } else {
                modal.setAttribute('open', '');
                modal.style.display = 'block';
                modal.style.visibility = 'visible';
                modal.style.opacity = '1';

                // If it's a modal-dialog with show method
                if (modal.show && typeof modal.show === 'function') {
                    modal.show();
                }
            }
        }

        // Exit intent detection
        exitIntentHandler = function(e) {
            if (exitIntentTriggered || popupShown) return;

            // Check if mouse is leaving the top of the viewport
            if (e.clientY <= 0) {
                exitIntentTriggered = true;
                showPopup();
            }
        };

        document.addEventListener('mouseleave', exitIntentHandler);

        // Schedule delayed popup (only if not triggered by exit intent)
        timeoutId = setTimeout(function() {
            if (!exitIntentTriggered && !popupShown) {
                // Check if user has scrolled or interacted
                const timeOnPage = Date.now() - pageLoadTime;
                if (timeOnPage >= DELAY_MIN) {
                    showPopup();
                } else {
                    // Wait until minimum time has passed
                    setTimeout(showPopup, DELAY_MIN - timeOnPage);
                }
            }
        }, DELAY_TIME);
    }

    // Run on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', findAndInterceptPopups);
    } else {
        findAndInterceptPopups();
    }

    // Also check after a short delay for dynamically loaded popups
    setTimeout(findAndInterceptPopups, 1000);
    setTimeout(findAndInterceptPopups, 3000);

    // Monitor for new modals added to DOM
    function setupDOMObserver() {
        if (!document.body) {
            // Wait for body to be available
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', setupDOMObserver);
            } else {
                setTimeout(setupDOMObserver, 100);
            }
            return;
        }

        const domObserver = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Element node
                            if (node.tagName === 'MODAL-DIALOG' ||
                                node.classList && (node.classList.contains('popup') || node.classList.contains('modal'))) {
                                setTimeout(findAndInterceptPopups, 100);
                            }
                        }
                    });
                }
            });
        });

        domObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    setupDOMObserver();
})();